import { render, staticRenderFns } from "./PrivacyBlock.vue?vue&type=template&id=1c1dfbd1"
import script from "./privacyBlock.ts?vue&type=script&lang=js&external"
export * from "./privacyBlock.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports